import React from 'react';

const SvgUserSolid = (props) => (
  <svg viewBox="0 0 448 512" {...props} id="UserSolid">
    <path fill="#fff" d="M0 0h448v512H0z" />
    <path d="M224 282c63.5 0 115-51.5 115-115S287.5 52 224 52s-115 51.5-115 115 51.5 115 115 115zm80.5 28.8h-15c-19.9 9.2-42.1 14.4-65.5 14.4s-45.5-5.2-65.5-14.4h-15c-66.7 0-120.8 54.1-120.8 120.8V469c0 23.8 19.3 43.1 43.1 43.1h316.3c23.8 0 43.1-19.3 43.1-43.1v-37.4c.1-66.8-54-120.8-120.7-120.8z" />
  </svg>
);

export default SvgUserSolid;
